import '../app';
import './client/index';
// import Swal from "sweetalert2";
import { createApp } from "vue";

import Swal from 'sweetalert2'

// Import your components from here
import CentralClientExampleComponent from "./client/components/CentralClientExampleComponent.vue";




const app = createApp({});
// app.use(new Swal);

// Mount components here
app.component("central-client-example-component", CentralClientExampleComponent);

// Ends here
app.mount("#app");
